var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var $ = require("./lib/qsa");
var pymChild = null;
var showMore = null; 

// var onWindowLoaded = function() {
//   pym.then(child => {
//     document.getElementById("medical").checked = true; // check first checkbox onload

//     child.sendHeight();
//     window.addEventListener("resize", () => child.sendHeight());
//   });
// }

pym.then(child => {
    pymChild = child;

    document.getElementById("medical").checked = true; // check onload
    toggleCategories();

    //add show more toggle on mobile
    showMore = $.one(".show-more");
    showMore.addEventListener('click', onToggleClicked);

    child.sendHeight();

    window.addEventListener("resize", () => child.sendHeight());
});

var radioItems = document.getElementById("radio");
var gridItems = document.querySelectorAll(".desc-wrapper");

radioItems.onchange = function() {
  toggleCategories();
}

var toggleCategories = function() {
    var categoryChecked = $(
    ".controls input[type=radio]:checked",
    radioItems
  ).map((el) => el.getAttribute("value"));

  var value = categoryChecked;
  console.log(value);
  clearClasses(gridItems);

  if (value != "") {
    gridItems.forEach(function(g) {
      if (value == "all") {
        clearClasses(gridItems);
      } else if (!value.some(r => g.classList.contains(r))) {
        // showAllCheck.checked = false;
        g.classList.add("hide");
        g.classList.remove("show");
        pymChild.sendHeight();
      }
    })
  }

  if (pymChild) {
    pymChild.sendHeight();
  }
}

var clearClasses = function(data) {
  data.forEach(function(item) {
    if (item.classList.contains("hide")) {
      item.classList.remove("hide");
    }

    if (!item.classList.contains("show")) {
      item.classList.add("show");
    }
  })
}

var onToggleClicked = function() {
  var grid = $.one(".graphic");
  if (grid.classList.contains("show-all")) {
    grid.classList.remove("show-all");
    showMore.textContent = showMore.dataset.more;
    pymChild.scrollParentToChildEl("grid");
  } else {
    grid.classList.add("show-all");
    showMore.textContent = showMore.dataset.less;
  }
  if (pymChild) {
    pymChild.sendHeight();
  }
}


// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
// window.addEventListener("load", onWindowLoaded);
